<template>
  <v-container class="grey-lighten-3 full-height">
      <v-row justify="center">
          <v-col cols="12" xl="10" lg="11" md="12">
              <v-sheet class="report-paper pa-5 mx-auto" elevation="3" id="printable-area">
              <div class="header-section d-flex justify-space-between mb-6 lines">
                  <div class="company-logo-area d-flex align-center">
                      <div class="logo-placeholder mr-4">
                      </div>
                      <div>
                          <v-img
                          :src="`${getFileServerUrl.replace(/\/$/, '')}/${getCurrentCompany?.logo_thumb || 'uploads/demo_images/user.png'}`"
                          width="200" height="100" class="rounded" />
                      </div>
                  </div>

                  <div class="company-address text-caption text-right">
                      <h1 class="company-name text-h5 font-weight-bold text-uppercase text-right">
                          {{ companyInfo.name }}
                      </h1>
                      <h1 class="text-subtitle-1 text-right">
                        UAE Address: Dnata Building Freight Gate 5 Building, Office no 210, 2nd Floor, Block E, Dubai Airport Free Zone Authorities Premises, DAFZA, Dubai. <br></br>
                        Cell: +971 507155639 & +971 566491905
                      </h1>
                  </div>
              </div>

              <!-- Title -->
              <div class="text-center mb-6">
                  <h2 class="report-title text-h6 font-weight-bold text-decoration-underline">
                      RECEIVED INVOICE
                  </h2>
              </div>

              <!-- Master Information -->
              <div class="meta-info-box mb-4" style="border: none;">
                <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
                  <tbody>
                    <tr>
                        <td style="width: 50%; border: 1px solid #000;">
                            <strong>Order No:</strong> {{ code }}
                        </td>
                        <td style="width: 50%; border: 1px solid #000;">
                            <strong>Receive No:</strong> {{ receive_no }}
                        </td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #000;">
                            <strong>Customer Chalan No:</strong> {{ chalan_no }}
                        </td>
                        <td style="border: 1px solid #000;">
                            <strong>Port Of Loading:</strong> {{ from_port }}
                        </td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #000;">
                            <strong>Receive Date:</strong> {{ receive_date }}
                        </td>
                        <td style="border: 1px solid #000;">
                            <strong>Port Of Destination:</strong> {{ to_port }}
                        </td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #000;">
                            <strong>Buyer Name:</strong> {{ buyer_name }}
                        </td>
                        <td style="border: 1px solid #000;">
                            <strong>Commodity:</strong> {{ commodity }}
                        </td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #000;">
                            <strong>Shop Name:</strong> {{ buyer_company_name }}
                        </td>
                        <td style="border: 1px solid #000;">
                            <strong>Shipper Name:</strong> {{ shipper_name }}
                        </td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #000;">
                            <strong>Buyer Phone:</strong> {{ buyer_phone }}
                        </td>
                        <td style="border: 1px solid #000;">
                            <strong>Shipper Company Name:</strong> {{ shipper_company_name }}
                        </td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #000;">
                            <strong>Shipment Mode:</strong> {{ shipment_mode }}
                        </td>
                        <td style="border: 1px solid #000;">
                            <strong>Shipper Phone:</strong> {{ shipper_phone }}
                        </td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #000;">
                            <strong>Sales Person:</strong> {{ sales_person }}
                        </td>
                        <td style="border: 1px solid #000;">
                            <strong>Mode Of Payment:</strong> {{ payment_mode }}
                        </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Depreciation Details Table -->
              <div class="table-container mb-6">
                  <table class="dep-table">
                      <thead>
                          <tr>
                              <th class="text-center" style="width: 40px;">SL</th>
                              <th>Product Name</th>
                              <th>Category</th>
                              <th>Calc. Type</th>
                              <th>Qty</th>
                              <th>Product Qty</th>
                              <th>CBM Meas.</th>
                              <th>CBM</th>
                              <th>Rate</th>
                              <th>Amount</th>
                              <th>Remarks</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(detail, index) in cart" :key="detail.id">
                              <td class="text-center">{{ index + 1 }}</td>
                              <td class="text-left">{{ detail.product_name }}</td>
                              <td class="text-left">{{ detail.category}}</td>
                              <td class="text-left">{{ detail.calc_type}}</td>
                              <td class="text-right">{{ detail.bag }}</td>
                              <td class="text-right">{{ detail.qty }}</td>
                              <td class="text-right">{{ detail.cbm_meas }}</td>
                              <td class="text-right">{{ detail.cbm }}</td>
                              <td class="text-right">{{ detail.rate }}</td>
                              <td class="text-right">{{ detail.total }}</td>
                              <td class="text-left">{{ detail.remarks }}</td>
                          </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colspan="4" class="text-center">TOTAL</th>
                          <th class="text-right">{{ cart.reduce((prev, cur) => { return +prev + +cur.bag }, 0) ?? 0 }}</th>
                          <th class="text-right">{{ cart.reduce((prev, cur) => { return +prev + +cur.qty }, 0) ?? 0 }}</th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th class="text-right">{{ cart.reduce((prev, cur) => { return +prev + +cur.total }, 0) ?? 0 }}</th>
                          <th></th>
                        </tr>
                      </tfoot>
                  </table>
              </div>

              <v-col class="justify-space-between">
                <p colspan="3" style="color: #333;"> <small><b>In words:</b> {{ convertNumberToWords(total) }}</small></p>
              </v-col>

               <v-col cols="12">
                  <div class="mb-6" style="font-size: 10px;">
                  <strong>Payment Terms & Conditions:</strong>
                  <div v-html="getSlsLetterInfo[0]?.terms">
                  </div>
                  <p class="text-center">I have read and understood the above instructions carefully and obliged then handed over the goods with signed</p>

                  </div>
              </v-col>

              <v-col cols="12">
                <v-row>
                     <v-col cols="4">
                        <p style="border-top: 1px solid #555; width:200px; margin: 0 auto; color: #333; text-align:center">
                          <span>Exporter Signature</span>
                        </p>
                      </v-col>
                      <v-col cols="4"></v-col>
                      <v-col cols="4">
                        <p style="border-top: 1px solid #555; width: 200px; margin: 0 auto; color: #333; text-align:center">
                          <span>Authorized Signature</span>
                        </p>
                      </v-col>

                      <v-col cols="12" class="d-flex flex-column">
                        <div><b>Concern Name:</b> {{ shipper_name }}</div>
                        <div><b>Mobile:</b> {{ shipper_phone }}</div>
                        <div><b>Company Name:</b> {{ shipper_company_name }}</div>
                      </v-col>
                      <v-col cols="12" class="d-flex justify-center">
                        <v-btn color="primary" class="mr-2" @click="printInvoice">
                          <v-icon left>mdi-printer</v-icon> Print
                        </v-btn>
                        <!-- <v-btn color="success" @click="downloadInvoice(sale_order_master_id)">
                          <v-icon left>mdi-file-pdf-box</v-icon> Download
                        </v-btn> -->
                      </v-col>
                </v-row>
              </v-col>
              </v-sheet>
          </v-col>
      </v-row>

        <!-- Action Toolbar (Hidden on Print) -->
      <v-row class="d-print-none mb-4" justify="center">
          <v-col cols="12" md="8" lg="9" class="d-flex justify-center gap-2">
              <!-- <v-btn color="success" prepend-icon="mdi-download" @click="downloadPDF">
                  Print PDF
              </v-btn> -->
          </v-col>
      </v-row>
  </v-container>


</template>

<script>
import convertNumberToWords from "@/plugins/numberToWord";
import formatDateView from "@/plugins/dateFormatView";
import { shipModeLabel, payModeLabel, categoryLabel, calTypeLabel } from "@/plugins/helpers.js";
import { prefix } from "@/store/api";
import Axios from "axios";
export default {
  data() {
    return {
      showPrintPreview: false,
      sale_order_master_id: '',
      code: '',
      receive_date: '',
      receive_no: '',
      chalan_no: '',
      commodity: '',
      payment_mode: '',
      delivery_address: '', 
      port_of_loading: '',
      port_of_destination: '',
      shipment_mode: '',
      buyer_name: '',
      buyer_company_name: '',
      buyer_phone: '',
      shop_name: '',
      shipper_name: '',
      shipper_company_name: '',
      shipper_phone: '',
      sales_person: '',
      description: '',
      from_port: '',
      to_port: '',
      previous_due: '',
      due: '',
      paid: '',
      payment_terms: '',
      discount_amount: '',
      tax_type: '',
      tax_amount: '',
      vat_type: '',
      vat_amount: '',
      sub_total: '',
      total: '',
      companyInfo: {
        name: "Time X Group.",
        mobile: "+88-02222288648, +88-02222289278",
        address: "Red Crescent Concord Tower 17, Unit 10/B, Mohakhali C/A, Dhaka-1212, Bangladesh",
        email: "info@remexcorp.com",
        code: '',
        bin_no: '',
        tin_no: '',
        group_head_ind: '',
        logo: '',
        logo_thumb: '',
        website: ''
      },
      customer: {
        customer_name: '',
        code: '',
        customer_owner_name: '',
        customer_mobile: '',
        customer_email: '',
        customer_address: '',
      },
      supplier: {
        customer_name: '',
      },
      cart: [],
      prefix: prefix
    };
  },
  methods: {
    convertNumberToWords,
    
    formatDateView,

    formatDate(date) {
          if (!date) return "-";
          const d = new Date(date);
          return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
              .toString()
              .padStart(2, "0")}/${d.getFullYear()}`;
      },
      formatDateTime(dateTime) {
          if (!dateTime) return "-";
          const d = new Date(dateTime);
          return `${this.formatDate(dateTime)} ${d.toLocaleTimeString()}`;
      },
      formatNumber(num) {
          return num ? Number(num).toFixed(2) : "0.00";
      },

    async downloadInvoice(id) {
      // const token = localStorage.getItem("token");
      try {
        const response = await Axios.get(`${prefix}sales/make-so-invoice-pdf/${id}`, {
          responseType: "blob",
          // headers: {
          //   Authorization: `Bearer ${token}`,
          // },
        });

        // Create URL and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        // window.open(url, "_blank");
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `invoice-${id}.pdf`);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error("Download failed:", error);
      }
    },
    async printInvoice() {
      // const printContent = document.querySelector('#invoice-content').innerHTML;
      // const originalContent = document.body.innerHTML;
      // document.body.innerHTML = `
      //   <div class="print-content">${printContent}</div>
      // `;
      // window.print();
      // document.body.innerHTML = originalContent;

      // return;
    
      // Use Option 1 (document.write) - RECOMMENDED
      // const printContent = document.getElementById('invoice-content').innerHTML;
      // const addressLines = this.companyInfo.address.split('\n').filter(line => line.trim());
      // ${addressLines.map(line => `<p>${line}</p>`).join('')}
      //  .table>:not(caption)>*>* {
      //                 background-color: unset;
      //               }
      let printWindow = window.open('', 'PRINT', `width=${screen.width}, height=${screen.height}, left=0, top=0`);
      printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                  <meta charset="UTF-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1.0">
                  <meta http-equiv="X-UA-Compatible" content="ie=edge">
                  <title>Invoice</title>
                  <link rel="preconnect" href="https://fonts.googleapis.com">
                  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                  <link href="https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400..700;1,400..700&display=swap" rel="stylesheet">
                  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-sRIl4kxILFvY47J16cr9ZwB07vP4J8+LH7qKQnuqkuIAvNWLzeN8tE5YBujZqJLB" crossorigin="anonymous">
                  <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
                  <style>
                    body {
                      font-family: 'Arimo', sans-serif;
                      margin: 0px;
                      font-size: 10px;
                    }
                    .invoice-header {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      border-bottom: 2px solid #eee;
                      padding-bottom: 10px;
                    }
                    .invoice-header img {
                      max-height: 70px;
                      max-width: 150px;
                    }
                    .table th, .table td {
                      border: 1px solid #000;
                      padding: 8px;
                      vertical-align: middle;
                    }
                    .table th {
                      background-color: #f0f0f0;
                      color: #333;
                    }
                    .table td {
                      background-color: unset;
                    }
                    .text-end {
                      text-align: right;
                    }
                    .text-center {
                      text-align: center;
                    }
                    h4 {
                      font-size: 20px;
                      color: #333;
                    }
                    p {
                      font-size: 14px;
                      color: #555;
                      margin: 2px 0;
                    }
                    strong {
                      font-weight: bold;
                      color: #333;
                    }
                    .signature-line {
                      border-top: 1px solid #555;
                      width: 200px;
                      margin: 0 auto;
                      text-align: center;
                      color: #333;
                    }
                    @page {
                      margin: 0.5in;
                      size: letter;
                    }
                    .company-logo img { max-width: 200px; height: auto; }
                    .logo-container {
                      display: flex;
                      align-items: center;
                    }
                    .logo-container img {
                      margin-right: 10px;
                    }
                    .watermark {
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      background-image: url('${this.getCurrentCompany.logo_thumb ? this.getFileServerUrl + this.getCurrentCompany.logo_thumb : '@/assets/image/logo.png'}');
                      background-repeat: no-repeat;
                      background-position: center;
                      background-size: contain;
                      width: 80%; 
                      height: 80%;
                      opacity: 0.1;
                      z-index: -1;
                      pointer-events: none;
                    }

                    .header-section {
                        display: flex;
                        flex-direction: flex !important;
                    }
                    .company-address {
                        text-align: left !important;
                    }
                    .full-height {
                        min-height: 100vh;
                    }
                    .grey-lighten-3 {
                        background-color: #eeeeee !important;
                    }
                    .report-paper {
                        background-color: white;
                        color: black;
                        font-family: 'Times New Roman', serif;
                        max-width: 280mm;
                        width: 100%;
                        min-height: 297mm;
                    }
                    .company-name {
                        color: #444;
                        letter-spacing: 1px;
                    }
                    .report-title {
                        text-decoration: underline;
                        text-underline-offset: 4px;
                    }
                    .meta-info-box {
                        border: 1px solid #000;
                    }
                    .meta-item {
                        height: 35px;
                    }
                    .meta-label {
                        font-weight: 500;
                        color: #333;
                    }
                    .dep-table {
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 14px;
                    }
                    .dep-table th {
                        background-color: #e0e0e0;
                        border: 1px solid #000;
                        padding: 6px 5px;
                    }
                    .dep-table td {
                        border: 1px solid #000;
                        padding: 6px 5px;
                        vertical-align: top;
                    }
                    .lines {
                        border-bottom: 1px solid #ccc;
                        padding-bottom: 5px;
                    }
                    .text-center {
                        text-align: center;
                    }
                    .text-right {
                        text-align: right;
                    }
                    .gap-2 {
                      gap: 8px;
                    }
                    .pl-2 {
                        padding-left: 8px !important;
                    }
                  </style>
                </head>
                <body>
                  <div id="printable" class="paper position-relative">
                    <div class="watermark"></div>

                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div class="company-logo text-end company-logo">
                        <img src="${this.getCurrentCompany.logo_thumb ? this.getFileServerUrl + this.getCurrentCompany.logo_thumb : '@/assets/image/logo.png'}" alt="Logo" class="img-fluid" />
                      </div>
                      <div>
                        <h5 class="mb-0 text-uppercase text-right">${this.getCurrentCompany?.name || this.companyInfo?.name}</h5>
                        <p class="mb-0 text-right" style="font-size:14px">
                          UAE Address: Dnata Building Freight Gate 5 Building, Office no 210, 2nd Floor, Block E, Dubai Airport Free Zone Authorities Premises, DAFZA, Dubai. <br>
                          Cell: +971 507155639 & +971 566491905 
                        </p>
                      </div>
                      
                    </div>
                      
                      <h6 class="text-center mb-3"><strong>RECEIVED INVOICE</strong></h6>   

                      <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
                        <tbody>
                          <tr>
                              <td style="width: 50%; border: 1px solid #000;">
                                  <strong>Order No:</strong> ${this.code}
                              </td>
                              <td style="width: 50%; border: 1px solid #000;">
                                  <strong>Receive No:</strong> ${this.receive_no}
                              </td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid #000;">
                                  <strong>Customer Chalan No:</strong> ${this.chalan_no}
                              </td>
                              <td style="border: 1px solid #000;">
                                  <strong>Port Of Loading:</strong> ${this.from_port}
                              </td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid #000;">
                                  <strong>Receive Date:</strong> ${this.receive_date}
                              </td>
                              <td style="border: 1px solid #000;">
                                  <strong>Port Of Destination:</strong> ${this.to_port}
                              </td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid #000;">
                                  <strong>Buyer Name:</strong> ${this.buyer_name}
                              </td>
                              <td style="border: 1px solid #000;">
                                  <strong>Commodity:</strong> ${this.commodity}
                              </td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid #000;">
                                  <strong>Shop Name:</strong> ${this.buyer_company_name}
                              </td>
                              <td style="border: 1px solid #000;">
                                  <strong>Shipper Name:</strong> ${this.shipper_name}
                              </td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid #000;">
                                  <strong>Buyer Phone:</strong> ${this.buyer_phone}
                              </td>
                              <td style="border: 1px solid #000;">
                                  <strong>S. Company Name:</strong> ${this.shipper_company_name}
                              </td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid #000;">
                                  <strong>Shipment Mode:</strong> ${this.shipment_mode}
                              </td>
                              <td style="border: 1px solid #000;">
                                  <strong>Shipper Phone:</strong> ${this.shipper_phone}
                              </td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid #000;">
                                  <strong>Sales Person:</strong> ${this.sales_person}
                              </td>
                              <td style="border: 1px solid #000;">
                                  <strong>Mode Of Payment:</strong> ${this.payment_mode}
                              </td>
                          </tr>
                        </tbody>
                      </table>
                    <table class="table mt-4">
                      <thead>
                        <tr>
                          <th>SL</th>
                          <th>PRODUCT NAME</th>
                          <th>CATEGORY</th>
                          <th>BAG/CTN</th>
                          <th>QTY</th>
                          <th>CBM MEAS.</th>
                          <th>CBM</th>
                          <th>RATE</th>
                          <th>TOTAL</th>
                          <th>REMARKS</th>
                        </tr>
                      </thead>
                      <tbody>
                        ${this.cart.map((product, key) => `
                          <tr>
                            <td class="text-center">${ key + 1 }</td>
                            <td class="text-left">${ product.product_name }</td>
                            <td class="text-left">${ product.category}</td>
                            <td class="text-right">${ product.bag }</td>
                            <td class="text-right">${ product.qty }</td>
                            <td class="text-right">${ product.cbm_meas }</td>
                            <td class="text-right">${ product.cbm }</td>
                            <td class="text-right">${ product.rate }</td>
                            <td class="text-right">${ product.total }</td>
                            <td class="text-right">${ product.remarks }</td>
                          </tr>
                        `).join('')}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colspan="3" class="text-center">TOTAL</th>
                          <th class="text-right">${ this.cart.reduce((prev, cur) => { return +prev + +cur.bag }, 0) ?? 0 }</th>
                          <th class="text-right">${ this.cart.reduce((prev, cur) => { return +prev + +cur.qty }, 0) ?? 0 }</th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th class="text-right">${ this.cart.reduce((prev, cur) => { return +prev + +cur.total }, 0) ?? 0 }</th>
                          <th></th>
                        </tr>
                      </tfoot>
                    </table>
                    <div class="row">
                      <div class="col-sm-12">
                        <p><strong>In words:</strong> ${this.convertNumberToWords(this.total)}</p>
                      </div>

                      <div class="col-sm-12" style="font-size: 8px !important;">
                        <p><strong>Payment Terms & Conditions:</strong></p>
                        ${this.getSlsLetterInfo[0]?.terms}
                        <p class="text-center">I have read and understood the above instructions carefully and obliged then handed over the goods with signed</p>
                      </div>
                    </div>
                    <br><br><br>
                    <div class="row">
                      <div class="col-sm-4 text-center">
                        <p class="signature-line">Exporter Signature</p>
                      </div>
                      <div class="col-sm-4"></div>
                      <div class="col-sm-4 text-center">
                        <p class="signature-line">Authorized Signature</p>
                      </div>
                      <div class="col-sm-12">
                        <br>
                        <div><b>Concern Name:</b> ${this.shipper_name }</div>
                        <div><b>Mobile:</b> ${this.shipper_phone }</div>
                        <div><b>Company Name:</b> ${this.shipper_company_name }</div>
                      </div>
                    </div>
                  </div>
                </body>
                </html>
              `);
      // printWindow.document.close();
      printWindow.moveTo(0, 0);
      printWindow.focus();
      await new Promise(resolve => setTimeout(resolve, 1000));
      printWindow.print();
      printWindow.close();
    }
  },
  created(){
    if(this.$store.getters.getSlsLetterInfo.length === 0) {this.$store.dispatch('getSlsLetterInfo');}
  },
  computed: {
    getCurrentCompany() {
      this.companyInfo = this.$store.getters.getCurrentCompany;
      console.log(this.companyInfo)
      return this.$store.getters.getCurrentCompany;
    },
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl;
    },
    getSlsLetterInfo() {
      return this.$store.getters.getSlsLetterInfo;
    }
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.$nextTick(() => {
        this.$store
          .dispatch("getSaleOrderById", id)
          .then((data) => {
              let saleOrder = data;
              this.sale_order_master_id = saleOrder.id
              this.code = saleOrder.code
              this.receive_date = saleOrder.receive_date
              this.receive_no = saleOrder.receive_no
              this.chalan_no = saleOrder.chalan_no
              this.commodity = saleOrder.commodity
              this.from_port = saleOrder.from_port?.name
              this.to_port = saleOrder.to_port?.name
              this.payment_mode = payModeLabel(saleOrder.payment_mode)
              this.shipment_mode = shipModeLabel(saleOrder.shipment_mode)
              this.shipper_name = saleOrder.supplier?.customer_name || "",
              this.shipper_company_name = saleOrder.shipper_company_name || "",
              this.shipper_phone = saleOrder.shipper_phone || "",
              this.sales_person = saleOrder.sale_by?.name || "",
              this.delivery_address = saleOrder.delivery_address
              this.description = saleOrder.description
              this.customer = saleOrder.customer
              this.buyer_name = saleOrder.customer?.customer_name || "",
              this.buyer_company_name = saleOrder.shop_name || "",
              this.buyer_phone = saleOrder.buyer_phone || "",
              this.previous_due = saleOrder.previous_due
              this.due = saleOrder.due
              this.paid = saleOrder.paid
              this.payment_terms = saleOrder.payment_terms
              this.discount_amount = saleOrder.discount_amount
              this.tax_type = saleOrder.tax_type
              this.tax_amount = saleOrder.tax_amount
              this.vat_type = saleOrder.vat_type
              this.vat_amount = saleOrder.vat_amount
              this.sub_total = saleOrder.sub_total
              this.total = saleOrder.total

              this.customer = {
                customer_name: saleOrder.customer?.customer_name || "",
                code: saleOrder.customer?.code || "",
                customer_owner_name: saleOrder.customer?.customer_owner_name || "",
                customer_mobile: saleOrder.customer?.customer_mobile || "",
                customer_email: saleOrder.customer?.customer_email || "",
                customer_address: saleOrder.customer?.customer_address || "",
                logo: saleOrder.customer?.logo || "",
                logo_thumb: saleOrder.customer?.logo_thumb || "",
                customer_website: saleOrder.customer?.customer_website || ""
              };

              this.supplier = {
                supplier_name: saleOrder.supplier?.supplier_name || "",
              },

              this.cart = [];
              (saleOrder.details || []).forEach((item) => {
                  this.cart.push({
                    product_id: item.product_id,
                    product_name: item.product?.name || "",
                    product_code: item.product.code || "",
                    category: categoryLabel(item.category) || "",
                    calc_type: calTypeLabel(item.calc_type) || "",
                    qty: item.qty,
                    bag: item.bag,
                    cbm: item.cbm,
                    cbm_meas: item.cbm_meas,
                    rate: item.rate,
                    total: item.total,
                    remarks: item.remarks || "",
                  });
              });
          })

          .catch((error) => {
            console.error("Failed to fetch sale order:", error);
          });
      });
    }
  }
};
</script>

<style scoped>
.header-section {
    display: flex;
    flex-direction: flex !important;
}
/* .company-address {
    text-align: left !important;
} */
.full-height {
    min-height: 100vh;
}
.grey-lighten-3 {
    background-color: #eeeeee !important;
}
.report-paper {
    background-color: white;
    color: black;
    font-family: 'Times New Roman', serif;
    max-width: 280mm;
    width: 100%;
    min-height: 297mm;
}
.company-name {
    color: #444;
    letter-spacing: 1px;
}
.report-title {
    text-decoration: underline;
    text-underline-offset: 4px;
}
.meta-info-box {
    border: 1px solid #000;
}
.meta-item {
    height: 35px;
}
.meta-label {
    font-weight: 500;
    color: #333;
}
.dep-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}
.dep-table th {
    background-color: #e0e0e0;
    border: 1px solid #000;
    padding: 6px 5px;
}
.dep-table td {
    border: 1px solid #000;
    padding: 6px 5px;
    vertical-align: top;
}
.lines {
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
}
.text-center {
    text-align: center;
}
.text-right {
    text-align: right;
}
.gap-2 {
    gap: 8px;
}

@media print {
  
  body * {
    visibility: hidden;
  }
  .v-col.cols-10.offset-1, .v-col.cols-10.offset-1 * {
    visibility: visible;
  }
  .v-btn {
    display: none;
  }
  .v-card {
    border: none !important;
    box-shadow: none !important;
  }
  .v-table {
    width: 100% !important;
    border-collapse: collapse;
  }
  .v-table th, .v-table td {
    border: 1px solid #000;
    padding: 8px;
    text-align: left;
  }
  .v-table th {
    background-color: #f5f5f5;
  }
  .text-right {
    text-align: right !important;
  }
  .text-center {
    text-align: center !important;
  }
  @page {
    margin: 0.5in;
    size: letter;
  }
  .v-col.cols-10.offset-1 {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  h4 {
    font-size: 20px !important;
  }
  p {
    font-size: 14px !important;
  }
  strong {
    font-weight: bold;
  }
}
.logo {
  margin: 0 0 auto;
}
.text-subtitle-2 {
  color: #555 !important;
}
.text-sub-2 {
  font-size: 14px !important;
}
.print-preview-content {
  padding: 20px;
  background-color: #fff;
  border: 1px solid #ccc;
}
/* @import url('https://fonts.googleapis.com/css2?family=Arimo&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Material+Icons+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200'); */


  .simple-table {
    width: 100%;
    border-collapse: collapse;
  }

  .simple-table th,
  .simple-table td {
    border: 1px solid #000;
    padding: 6px;
    font-size: 11px;
  }

</style>